//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LandMap from "@/components/LandMap";
import MapLandInfoHorizontal from "@/components/LandMap/MapLandInfoHorizontal";
export default {
  name: "WorkAssignDetail",
  data() {
    return {
      id: "", // 作业类型ID
      orderId: "", //订单ID
      detail: {}, // 详情上半部分
      info: [], // 详情上半部分-表格内容
      landList: [], // 所有的地块
      trajectoryList: [], // 所有的轨迹块
      // 地图顶部信息配置项
      mapTopInfoOptions: {
        data: [
          { id: 2, name: "未派活", colour: "#ae8b71" },
          { id: 3, name: "已派活", colour: "#ff9600" },
          { id: 5, name: "作业中", colour: "#007eff" },
          { id: 6, name: "作业完成", colour: "#1cba33" },
        ],
      },
      // 地图右部信息配置项
      mapRightInfoOptions: {
        landInfoType: "horizontal", //地块信息样式：vertical 纵向即一行一列，Horizontal横向即一行多列
        hasLandInfoForLandDetail: true, // 地块信息面板是否有地块信息切卡
        hasWorkInfoForLandDetail: true, // 地块信息面板是否有作业信息切卡
        hasAuditInfoForLandDetail: true, // 地块信息面板是否有审核信息切卡
        hasTrajectoryPlayBtn: true, // 是否有轨迹回放按钮
      },
      // 地图底部信息配置项
      mapBottomInfoOptions: {
        hasMapBottomInfo: true, // 是否有底部信息
        orderId: "", // 订单ID
        workTypeId: "", // 作业类型ID
      },
      orderCategory: 2,
    };
  },
  components: {
    LandMap,
    MapLandInfoHorizontal,
  },
  filters: {
    formatWorkProgress(value) {
      let result = `${value}%`;
      return result;
    },
  },
  created() {
    let { id, order_id: orderId, orderCategory } = this.$route.query;
    this.id = id;
    this.orderId = orderId;
    this.mapBottomInfoOptions.orderId = orderId;
    this.mapBottomInfoOptions.workTypeId = id;
    this.orderCategory = orderCategory;
    this.getWorkTypeDetail();
    this.getWorkTypeLandList();
    this.getWorkTypeTrajectory();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     */
    getWorkTypeDetail() {
      this.$http.cooperative.getWorkTypeDetail({ id: this.id }).then((res) => {
        this.isRequest = true;
        this.detail = res.data;
        this.info = [res.data];
      });
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getWorkTypeLandList() {
      this.$http.cooperative
        .getWorkTypeLandList({ workTypeId: this.id })
        .then((res) => {
          this.landList = res.data;
        });
    },
    /**
     * @descripttion: 获取轨迹块
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:39:56
     */
    getWorkTypeTrajectory() {
      this.$http.cooperative
        .getWorkTypeTrajectory({ workTypeId: this.id })
        .then((res) => {
          this.trajectoryList = res.data;
        });
    },
  },
};
